import '../../../App.css';
import './AccountStatement.css';
import { useEffect, useState } from 'react';
import { Table, Input, Select, Pagination } from 'antd';
import axios from 'axios';
import moment from "moment";
import Appconfig from '../../../config/config'
import 'react-notifications/lib/notifications.css';
import 'react-datepicker/dist/react-datepicker.css';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import TextField from '@mui/material/TextField';
import { DatePicker, Button } from 'antd';
import dayjs from 'dayjs';

function AccountStatement({ user_id }) {
    const userInfo = JSON.parse(localStorage.getItem('userdata'))
    const { RangePicker } = DatePicker;

    // Default: from_date = 7 days ago at 11:59, to_date = today at 11:59
    const defaultFrom = moment().subtract(7, 'days').set({ hour: 11, minute: 59 }).toDate();
    const defaultTo = moment().set({ hour: 11, minute: 59 }).toDate();

    const [formData, setFormData] = useState({
        "user_id": user_id ? user_id : userInfo._id,
        "type": "0",
        "from_date": defaultFrom,
        "to_date": defaultTo,
        "game_type": "All",
    });

    // Format for display: dd:mm:yyyy
    // const formattedFromDate = formData.from_date ? moment(formData.from_date).format('DD:MM:YYYY HH:mm') : '';
    // const formattedToDate = formData.to_date ? moment(formData.to_date).format('DD:MM:YYYY HH:mm') : '';

    const defaultFromDayjs = dayjs(defaultFrom);
    const defaultToDayjs = dayjs(defaultTo);

    let locale = {
        emptyText: 'No data!',
    };
    const columns = [
        {
            title: 'Date/Time',
            dataIndex: 'createdAt',
            sorter: true,
            render: (_, record) => (
                <span className='font-extrabold text-[#212529] text-[0.813rem] '>{new Date(record.createdAt).toLocaleString()}</span>
            ),
        },
        {
            title: 'Deposit',
            dataIndex: 'amount',
            sorter: true,
            render: (_, record) => (
                record.transaction_type === "Credit" ?
                    <span className='font-extrabold text-[#508d0e] text-[0.813rem]'>{Number(record.amount).toFixed(2)}</span>
                    : '-'
            ),
        },
        {
            title: 'Withdraw',
            dataIndex: 'name',
            sorter: true,
            render: (_, record) => (
                record.transaction_type === "Debit" ?
                    <span className='font-extrabold text-[#d50000] text-[0.813rem]'>{Number(record.amount).toFixed(2)}</span>
                    : '-'
            ),
        },
        {
            title: 'Balance',
            dataIndex: 'balance',
            sorter: true,
            render: (_, record) => (
                <span className='font-extrabold text-[#212529] text-[0.813rem] '>{Number(record.balance).toFixed(2)}</span>
            ),
        },
        {
            title: 'Remarks',
            dataIndex: 'remarks',
            sorter: true,
            render: (_, record) => (
                <span className='font-extrabold text-[#212529] text-[0.813rem] '>{record.remarks}</span>
            ),
        },
        {
            title: 'From/To',
            sorter: true,
            render: (_, record) => (
                <span className='font-extrabold text-[#212529] text-[0.813rem] flex items-center justify-center'>
                    {record.from}
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="black" xmlns="http://www.w3.org/2000/svg">
                        <path d="M9 17V7L16 12L9 17Z" />
                    </svg>
                    {record.to}
                </span>
            ),
        },
    ];
    const [data, setData] = useState([])
    const [current, setCurrent] = useState(1);
    const [pageSize, setPageSize] = useState(10);

    const handlePageSizeChange = (e) => {
        setPageSize(e);
        setCurrent(1);
    };

    const handleFirst = () => setCurrent(1);
    const handleLast = () => setCurrent(Math.ceil(data.length / pageSize));

    const startIndex = (current - 1) * pageSize;
    const endIndex = Math.min(startIndex + pageSize, data.length);
    const paginatedData = data?.slice(startIndex, endIndex);

    const filterAccountStatement = async () => {
        // Format dates for API as 'YYYY-MM-DD HH:mm'
        const apiFormData = {
            ...formData,
            from_date: moment(formData.from_date).format('YYYY-MM-DD HH:mm'),
            to_date: moment(formData.to_date).format('YYYY-MM-DD HH:mm'),
        };

        var dataStr = JSON.stringify(apiFormData);
        var config = {
            method: 'post',
            url: `${Appconfig.apiUrl}reports/aurafilteraccountStatement`,
            headers: {
                'Content-Type': 'application/json'
            },
            data: dataStr
        };

        axios(config)
            .then(function (response) {
                setData(response.data.resultData);
            })
            .catch(function (error) {
                console.log(error);
            });
    }

    useEffect(() => {
        filterAccountStatement();
        // eslint-disable-next-line
    }, [])

    const onChangeDataType = (datatype) => {
        if (datatype === "LIVE") {
            setFormData({
                ...formData,
                from_date: moment().set({ hour: 11, minute: 59, second: 0, millisecond: 0 }).toDate()
            })
        } else if (datatype === "BACKUP") {
            setFormData({
                ...formData,
                from_date: moment().subtract(3, 'month').set({ hour: 11, minute: 59, second: 0, millisecond: 0 }).toDate()
            })
        } else if (datatype === "OLD") {
            setFormData({
                ...formData,
                from_date: moment().subtract(1, 'year').set({ hour: 11, minute: 59, second: 0, millisecond: 0 }).toDate()
            })
        }
    }

    return (
        <div className="deposit-statement-page">

            {/* Date Filter Section */}
            <section className="deposit-filter-card">

                <div className="deposit-filter-grid">

                    <div className="deposit-filter-field">
                        <label>From</label>

                        <DatePicker
                            showTime={{
                                format: "HH:mm",
                            }}
                            format="DD-MM-YYYY HH:mm"
                            value={dayjs(
                                formData.from_date
                            )}
                            className="deposit-date-picker"
                            onChange={(
                                date,
                                dateString
                            ) => {
                                if (!date) {
                                    return;
                                }

                                setFormData({
                                    ...formData,
                                    from_date: dayjs(
                                        dateString,
                                        "DD-MM-YYYY HH:mm"
                                    ).toDate(),
                                });
                            }}
                        />
                    </div>

                    <div className="deposit-filter-field">
                        <label>To</label>

                        <DatePicker
                            showTime={{
                                format: "HH:mm",
                            }}
                            format="DD-MM-YYYY HH:mm"
                            value={dayjs(
                                formData.to_date
                            )}
                            className="deposit-date-picker"
                            onChange={(
                                date,
                                dateString
                            ) => {
                                if (!date) {
                                    return;
                                }

                                setFormData({
                                    ...formData,
                                    to_date: dayjs(
                                        dateString,
                                        "DD-MM-YYYY HH:mm"
                                    ).toDate(),
                                });
                            }}
                        />
                    </div>

                    <div className="deposit-filter-action">
                        <Button
                            type="primary"
                            onClick={
                                filterAccountStatement
                            }
                            className="deposit-filter-button"
                        >
                            Get Statement
                        </Button>
                    </div>

                </div>
            </section>


            {/* Deposit & Withdraw Section */}
            <section className="deposit-history-card">

                <div className="deposit-history-header">
                    <span>Deposit &amp; Withdraw</span>
                </div>

                <div className="deposit-history-body">

                    <Table
                        title={() => (
                            <div className="deposit-table-toolbar">

                                <div className="deposit-page-size">
                                    <label>
                                        <span>Show</span>

                                        <Select
                                            value={pageSize}
                                            onChange={
                                                handlePageSizeChange
                                            }
                                            className="deposit-pagesize-select"
                                        >
                                            <Select.Option value={10}>
                                                10
                                            </Select.Option>

                                            <Select.Option value={25}>
                                                25
                                            </Select.Option>

                                            <Select.Option value={50}>
                                                50
                                            </Select.Option>

                                            <Select.Option value={100}>
                                                100
                                            </Select.Option>
                                        </Select>

                                        <span>entries</span>
                                    </label>
                                </div>

                                <div className="deposit-search">
                                    <label>
                                        <span>Search:</span>

                                        <Input
                                            allowClear
                                            placeholder="Search statement"
                                            className="deposit-search-input"
                                        />
                                    </label>
                                </div>

                            </div>
                        )}
                        locale={locale}
                        columns={columns}
                        className="deposit-history-table"
                        bordered
                        dataSource={paginatedData}
                        pagination={false}
                        scroll={{
                            x: "max-content",
                        }}
                        rowKey={(record, index) =>
                            record?._id ||
                            [
                                record?.createdAt,
                                record?.transaction_type,
                                record?.amount,
                                index,
                            ].join("-")
                        }
                    />

                    <div className="deposit-pagination-row">

                        <div className="deposit-entry-info">
                            Showing{" "}
                            {data.length > 0
                                ? startIndex + 1
                                : 0}{" "}
                            to{" "}
                            {Math.min(
                                endIndex,
                                data.length
                            )}{" "}
                            of {data.length} entries
                        </div>

                        <div className="deposit-pagination-controls">

                            <button
                                type="button"
                                className="deposit-pagination-button"
                                onClick={handleFirst}
                                disabled={current === 1}
                            >
                                First
                            </button>

                            <Pagination
                                current={current}
                                pageSize={pageSize}
                                total={data.length}
                                onChange={(page) =>
                                    setCurrent(page)
                                }
                                className="deposit-pagination"
                                itemRender={(
                                    page,
                                    type,
                                    originalElement
                                ) => {
                                    if (type === "prev") {
                                        return (
                                            <span className="deposit-page-link">
                                                Previous
                                            </span>
                                        );
                                    }

                                    if (type === "page") {
                                        return null;
                                    }

                                    if (type === "next") {
                                        return (
                                            <span className="deposit-page-link">
                                                Next
                                            </span>
                                        );
                                    }

                                    return originalElement;
                                }}
                                showSizeChanger={false}
                            />

                            <button
                                type="button"
                                className="deposit-pagination-button"
                                onClick={handleLast}
                                disabled={
                                    current >=
                                    Math.max(
                                        1,
                                        Math.ceil(
                                            data.length /
                                            pageSize
                                        )
                                    )
                                }
                            >
                                Last
                            </button>

                        </div>
                    </div>

                </div>
            </section>
        </div>
    );
}

export default AccountStatement;